import {
  getCloudflareImageUrl,
  getStaticUrl,
} from '@/hooks/useCloudflareImage';

const fetchImgWidth = 280;
const imgWidth = 120;
const imgHeight = 80;
const assetsRoot = '/portfolio/create-portfolio-features/';
const brokerSync = {
  title: 'Broker Sync or Easy Upload',
  img: getCloudflareImageUrl({
    src: getStaticUrl(assetsRoot + 'broker-sync.png'),
    width: fetchImgWidth,
  }),
};
const valuation = {
  title: 'Fair Value & Performance Tracking',
  img: getCloudflareImageUrl({
    src: getStaticUrl(assetsRoot + 'valuation.png'),
    width: fetchImgWidth,
  }),
};
const riskReward = {
  title: 'Opportunity & Risk Alerts',
  img: getCloudflareImageUrl({
    src: getStaticUrl(assetsRoot + 'risks-rewards.png'),
    width: fetchImgWidth,
  }),
};

const diversification = {
  title: 'Diversification Analysis',
  img: getCloudflareImageUrl({
    src: getStaticUrl(assetsRoot + 'diversification.png'),
    width: fetchImgWidth,
  }),
};

const dividends = {
  title: 'Dividend Insights & Forecasts',
  img: getCloudflareImageUrl({
    src: getStaticUrl(assetsRoot + 'dividends.png'),
    width: fetchImgWidth,
  }),
};
const devices = {
  title: 'Powerful Apple & Android Apps',
  img: getCloudflareImageUrl({
    src: getStaticUrl(assetsRoot + 'devices.png'),
    width: fetchImgWidth,
  }),
};

export const PromoFeatures = () => {
  return (
    <section className="grid gap-x3 grid-cols-1 md:grid-cols-[200px_auto] mt-x4 sm:mt-0 mx-x3 md:mx-0">
      <div className="text-center md:text-left">
        <p className="text-lg">What can you expect</p>
        <p className="text-xs text-softer">
          Get started in minutes to de-risk and improve your portfolio
        </p>
      </div>
      <div className="grid gap-x4 grid-cols-2 md:grid-cols-3 text-center text-wrap">
        <div>
          <img
            src={brokerSync.img}
            alt={brokerSync.title}
            width={imgWidth}
            height={imgHeight}
          />
          <p className="text-wrap">{brokerSync.title}</p>
        </div>
        <div>
          <img
            src={valuation.img}
            alt={valuation.title}
            width={imgWidth}
            height={imgHeight}
          />
          <p>{valuation.title}</p>
        </div>
        <div>
          <img
            src={riskReward.img}
            alt={riskReward.title}
            width={imgWidth}
            height={imgHeight}
          />
          <p>{riskReward.title}</p>
        </div>
        <div>
          <img
            src={diversification.img}
            alt={diversification.title}
            width={imgWidth}
            height={imgHeight}
          />
          <p>{diversification.title}</p>
        </div>
        <div>
          <img
            src={dividends.img}
            alt={dividends.title}
            width={imgWidth}
            height={imgHeight}
          />
          <p>{dividends.title}</p>
        </div>
        <div>
          <img
            src={devices.img}
            alt={devices.title}
            width={imgWidth}
            height={imgHeight}
          />
          <p>{devices.title}</p>
        </div>
      </div>
    </section>
  );
};
